const S = {
  CHEST_XRAY_SCANNING: "Chest X-Ray Scanning",
  SAMPLE_CHEST_XRAY_PRE_SCANNING: "Sample Chest X-Ray Scanning"
}, E = {
  SKIPPED: "SKIPPED",
  COMPLETED: "COMPLETED",
  DISCARDED: "DISCARDED"
};
export {
  E as SampleTestStatus,
  S as testTypes
};
